import { render, staticRenderFns } from "./bebidas.vue?vue&type=template&id=0b5f03b6&scoped=true&"
import script from "./bebidas.vue?vue&type=script&lang=js&"
export * from "./bebidas.vue?vue&type=script&lang=js&"
import style0 from "./bebidas.vue?vue&type=style&index=0&id=0b5f03b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f03b6",
  null
  
)

export default component.exports